import { useState } from "react";

export function useModalBehavior(defaultOpen: boolean = false) {
  const [open, setOpen] = useState(defaultOpen);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  return {
    open,
    openModal,
    closeModal,
  };
}
